import { toNestedObject as toNestedObjectWasm } from '@distribusion/alien_utils'

export const toNestedObject = (response: any, params: any): Object => {
  if (response?.jsonapi?.version == null) return response

  return toNestedObjectWasm(response, params)
}
